/**
 * DO NOT EDIT THIS FILE MANUALLY
 */
export const app = {
  name: 'ott-platform',
  version: '1.15.1',
}
